<head>
<script src="https://unpkg.com/vue"></script>
</head>
<template>
  <a-card title="Cadastro Prazos de Audiometria">
    <form ref="form" @submit.prevent="submitForm">
      <div key="unidade" class="row">
        <div class="col-md-8">
          <label for="unidade">Unidade</label><label style="margin-left: 1px; font-weight: bold; color: red">*</label>
          <br />
          <a-auto-complete v-model:value="registro.unidade.nome" @search="handleSearch" class="form-control border-left-0">
            <template v-slot:dataSource>
              <a-select-option v-for="item in unidadesFiltro" :key="item.nome" @click="onSelect(item)">
                {{ item.nome }}
              </a-select-option>
            </template>
          </a-auto-complete>
        </div>
      </div>
      <div class="row">
        <div class="col-md-4">
          <label for="prazo">Prazo</label><label style="margin-left: 1px; font-weight: bold; color: red">*</label>
          <br />
          <input v-model="registro.prazo" type="number" class="form-control form-input-component" required />
        </div>
        <div class="col-md-4">
          <div>
            <label for="status">Status</label><label style="margin-left: 1px; font-weight: bold; color: red">*</label>
            <br />
            <select v-model="registro.situacao" class="form-select form-input-component" required>
              <option value="ATIVO">Ativo</option>
              <option value="INATIVO">Inativo</option>
            </select>
          </div>
        </div>
      </div>
      <a-divider type="horizontal" />
      <div class="spaced-container">
        <button type="submit" class="btn btn-primary" @click="cadastrar">Salvar</button>
        <button class="btn btn-warning" @click="voltar">Voltar</button>
      </div>
    </form>
  </a-card>
</template>

<script>
import { openNotification, typesNotification } from '@/utils/notifications';
import { createPrazoAudiometria, getPrazoAudiometriaById } from '@/components/service/prazoAudiometriaService';
import { domainUPM } from '@/config/servicos-utils';

export default {
  name: 'FormManterPrazoAudiometria',
  setup() {
    return {};
  },
  data() {
    return {
      registro: { unidade: { id: null, nome: null }, prazo: null, situacao: null },
      unidades: [],
      unidadesFiltro: [],
    };
  },
  methods: {
    async cadastrar() {
      //this.v$.$validate()
      if (!this.$refs.form.checkValidity() || this.registro.unidade.id === null) {
        this.submitted = true;
        openNotification(typesNotification.warning, 'Informe os campos obrigatórios!');
      } else {
        await createPrazoAudiometria(this.registro).then(() => {
          //let retorno = r.data;
          if (!this.registro.id) {
            openNotification(typesNotification.success, 'Dados salvos com sucesso.');
          } else {
            openNotification(typesNotification.success, 'Dados alterados com sucesso.');
          }
          this.submitted = true;
          this.registro = { unidade: { id: null, nome: null }, prazo: null, situacao: null };
        });
      }
    },
    voltar() {
      this.$router.go(-1);
    },
    async carregarPrazoAudiometria() {
      if (this.$route.query.id) {
        const idUrl = this.$route.query.id;
        const res = await getPrazoAudiometriaById(idUrl);
        this.registro = { ...res.data, id: idUrl };
      }
    },
    onSelect(value) {
      this.registro.unidade = { id: value.id, nome: value.nome };
    },
    async getUnidade() {
      await domainUPM().then((r) => {
        r.data.forEach((unidade) => {
          this.unidades.push({ ...unidade, nome: unidade.nome.toUpperCase() });
        });
      });
    },
    async handleSearch(value) {
      if (value.length >= 2) {
        this.unidadesFiltro = this.unidades.filter((unidade) => unidade.nome.toUpperCase().includes(value.toUpperCase()));
      } else {
        this.unidadesFiltro = [];
      }
    },
  },

  created() {
    this.carregarPrazoAudiometria();
    this.getUnidade();
  },
};
</script>

<style>
.input-group-text {
  height: 38px;
}

.input-group-prepend {
  cursor: pointer;
  margin-left: 8px !important;
}

.input-group-text:hover {
  background-color: #e0e0e0 !important;
}

.h2 {
  font-size: x-large;
}

.spaced-container * {
  margin-top: 10px;
  margin-right: 10px;
}
</style>
